module.exports = __webpack_public_path__ + "./assets/img_zhongshan_color@2x__6f50f5840bdb4fbdb0d323f1ad3322d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/img_zhongshan_color@2x.jpg
// module id = 648
// module chunks = 12